import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import ReportsTable from "./allCustomersTable";

function AllCustomers() {
  const [orgData, setOrgData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  // 📌 Table Columns According to API Response
  const columns = [
    { Header: "Organization Name", accessor: "orgName", width: "35%" },
    { Header: "Email ID", accessor: "emailId", width: "20%" },
    { Header: "Organization ID", accessor: "orgId", width: "35%" },
    { Header: "Total Vehicles", accessor: "totalVehicle", width: "10%" },
  ];

  // 📌 Fetch ORG DETAILS API
  const fetchOrgDetails = async () => {
    setLoading(true);
    setErrorMessage("");

    try {
      const session = localStorage.getItem("token");
      if (!session) {
        setErrorMessage("Session missing. Please login again.");
        openErrorSB();
        setLoading(false);
        return;
      }

      const config = {
        method: "get",
        url: "https://v3.dhundhoo.com/superAdmin/orgDetails",
        headers: {
          "x-dhundhoo-session": session,
        },
      };

      const response = await axios.request(config);

      setOrgData(response.data || []);
      openSuccessSB();
    } catch (error) {
      console.error(error);
      setErrorMessage("Error fetching organization details");
      openErrorSB();
    } finally {
      setLoading(false);
    }
  };

  // 🔥 Auto load API on Component Mount
  useEffect(() => {
    fetchOrgDetails();
  }, []);

  // 📌 CSV Download
 const exportToCSV = () => {
  if (orgData.length === 0) {
    setErrorMessage("No data to export");
    openErrorSB();
    return;
  }

  // helper: wrap values in quotes to avoid CSV column break
  const wrap = (value) => `"${value ? String(value).replace(/"/g, '""') : ""}"`;

  const headers = [
    wrap("Organization Name"),
    wrap("Email ID"),
    wrap("Organization ID"),
    wrap("Total Vehicles"),
  ];

  const rows = orgData.map((row) =>
    [
      wrap(row.orgName),
      wrap(row.emailId),
      wrap(row.orgId),
      wrap(row.totalVehicle),
    ].join(",")
  );

  const csvContent = [headers.join(","), ...rows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "AllCustomersList.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>

              <MDBox p={3} pb={0} display="flex" justifyContent="flex-end" gap={2}>
                <MDButton
                  variant="gradient"
                  color="secondary"
                  size="small"
                  onClick={exportToCSV}
                  disabled={loading}
                >
                  DOWNLOAD CSV
                </MDButton>

                <MDButton
                  variant="outlined"
                  color="info"
                  size="small"
                  onClick={fetchOrgDetails}
                  disabled={loading}
                >
                  REFRESH
                </MDButton>
              </MDBox>

              {errorMessage && (
                <MDBox px={2} pt={2}>
                  <Alert severity="error">{errorMessage}</Alert>
                </MDBox>
              )}

              <MDBox pt={3} display="flex" justifyContent="center">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <ReportsTable
                    table={{ columns, rows: orgData }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={true}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Snackbars */}
      <MDSnackbar
        color="success"
        icon="check"
        title="Organization Details"
        content="Data loaded successfully"
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />

      <MDSnackbar
        color="error"
        icon="warning"
        title="Organization Details"
        content="Failed to load data. Please try again."
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default AllCustomers;
